import { Col, Row } from "reactstrap";
import Drawer from "../../../assets/vfx/drawer/drawer";
import DisplayData from "../../common/DisplayData/DisplayData";
import { QuestionDto } from "../../../services/dto";
import { QuestionLookupProps, QuestionTypes } from "./questionForm";
import { ConfirmationDialog } from "../../../assets/types";
import { Constants } from "../../../assets/utils/lib/constants";

interface QuestionViewProps {
  data: QuestionDto | undefined;
  show: boolean;
  lookups: QuestionLookupProps | undefined;
  onHide: () => void;
  onEdit: () => void;
  onDelete: () => void;
}

export const QuestionView = (props: QuestionViewProps) => {
  const questionType = props?.lookups?.questionType.find(
    (x: { value: any }) => x.value === props?.data?.questionTypeId
  )?.display;

  const sectionName = props?.lookups?.sections.find(
    (x: { value: any }) => x.value === props?.data?.sectionId
  )?.display;

  return (
    <>
      <Drawer.View
        className="w-30"
        show={props?.show}
        backdrop={true}
        placement="end"
        scroll={true}
        onHide={props?.onHide}
        onEdit={props?.onEdit}
        title="View Question"
        onDelete={props?.onDelete}
        modalDialogProps={new ConfirmationDialog().get(
          props.onDelete,
          "Delete",
          {
            Name: props?.data?.name ?? Constants.emptyString,
          }
        )}
      >
        <>
          <Row className="mb-3">
            <Col md={12}>
              <DisplayData
                text="Name"
                importedData={props?.data?.name}
              ></DisplayData>
            </Col>
          </Row>
          {props?.data?.description && (
            <Row className="mb-3">
              <Col md={12}>
                <DisplayData
                  text="Description"
                  importedData={props?.data?.description}
                ></DisplayData>
              </Col>
            </Row>
          )}
          <Row className="mb-3">
            <Col md={12}>
              <DisplayData
                text="Section"
                importedData={sectionName}
              ></DisplayData>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={12}>
              <DisplayData
                text="Question Type"
                importedData={questionType}
              ></DisplayData>
            </Col>
          </Row>
          {props?.data?.rangeMinValue && (
            <Row className="mb-3">
              <Col md={12}>
                <DisplayData
                  text="Min Value"
                  importedData={props?.data?.rangeMinValue}
                ></DisplayData>
              </Col>
            </Row>
          )}
          {props?.data?.rangeMaxValue && (
            <Row className="mb-3">
              <Col md={12}>
                <DisplayData
                  text="Max Value"
                  importedData={props?.data?.rangeMaxValue}
                ></DisplayData>
              </Col>
            </Row>
          )}
          <>
            {props?.data !== undefined &&
              props?.data !== null &&
              props?.data.questionTypeId &&
              (props?.data.questionTypeId ===
                QuestionTypes.Dropdown.toLowerCase() ||
                props?.data.questionTypeId ===
                  QuestionTypes.Checkbox.toLowerCase() ||
                props?.data.questionTypeId ===
                  QuestionTypes.Radio.toLowerCase()) &&
              props?.data?.options != undefined &&
              props?.data?.options?.length > 0 && (
                <>
                  <Row className="mb-3">
                    <Col md={12}>
                      <h4 className="mb-2">Options</h4>
                    </Col>
                  </Row>
                  {props?.data?.options?.map((option) => (
                    <Row className="mb-3" key={option?.id}>
                      <Col md={12}>
                        <DisplayData
                          text="Text"
                          importedData={option?.name}
                        ></DisplayData>
                      </Col>
                    </Row>
                  ))}
                </>
              )}
          </>
        </>
      </Drawer.View>
    </>
  );
};
